import { Observable } from 'rxjs';

export interface AccredibleBreadCrumb {
  name: Observable<string> | string;
  routerLink?: string;
  embeddingHrefUrl?: string;
}
